import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => {
  return {
    btnlink: (props) => {
      return {
        padding: "0",
        color: "#71B1F2",
        fontSize: 12,
        lineHeight: "12px",
        "&:last-child": {
          marginRight: 0,
        },
        [theme.breakpoints.down("xs")]: {
          marginRight: 10,
        },
      };
    },
    rotateIcon: {
      transform: "rotate(-45deg)",
    },
    copyLinkInput: {
      border: "solid 1px #ccc",
      padding: "3px 6px",
      borderRadius: 4,
      marginRight: 10,
    },
    visionCommentPopover: {
      "& Button": {
        "& img": {
          width: "20px !important",
          height: "auto !important",
        },
      },
    },
    visionLikePopover: {
      "& Button": {
        "& img": {
          width: "24px !important",
          height: "auto !important",
        },
      },
    },
    sendBtn: {
      "& button": {
        padding: 4,
        "& svg": {
          fontSize: 18,
        },
      },
    },
    commentTextarea: {
      "& .MuiInput-root": {
        "&:before": {
          border: "none",
        },
        "&:after": {
          border: "none",
        },
        "&:hover": {
          "&:before": {
            border: "none",
          },
        },
      },
      "& textarea": {
        minHeight: 60,
        maxHeight: 60,
        overflowY: "auto !important",
      },
    },
    clapIcon: {
      width: "24px !important",
      filter: "brightness(0) invert(1)",
      marginRight: 8,
    },
    visionCount: {
      background: "#A8A8A83D",
      width: 24,
      height: 24,
      borderRadius: 50,
      fontSize: 11,
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 6,
      cursor: "pointer",
    },
    commentList: {
      width: 250,
      borderBottom: "dashed 1px #C2BDBD",
      padding: "6px 15px",
      "&:last-child": {
        borderBottom: "none",
      },
    },
    selfComment: {
      position: "relative",
    },
    star: {
      position: "absolute",
      left: "14px",
      top: "30px",
    },
    profileBorder: {
      "& .MuiAvatar-root": {
        border: "solid 2px #BCC9D6",
      },
    },
    commentEditDelete: {
      position: "absolute",
      right: 3,
      top: 3,
      "& button": {
        padding: 3,
      },
    },
    blackBg: {
      "& .MuiPopover-paper": {
        background: "#393D4EE6",
        padding: 16,
      },
    },
    wordCloud: {
      width: 250,
      height: 250,
      "& text": {
        fontFamily: "inherit",
      },
    },
    emojiPicker: {
      padding: 4,
      "& svg": {
        transform: "rotate(0deg)",
        borderRadius: 50,
        color: "#A0A0A0",
      },
    },
    commentTextArea: {
      "& .MuiInputBase-inputMultiline": {
        maxHeight: 100,
        overflowY: "auto !important",
      },
    },
    grayBtn: {
      color: "#eee",
    },
    coachInfo: {
      lineHeight: "12px",
      minWidth: 40,
    },
    coacheeList: {
      width: 250,
      padding: "6px 15px",
      marginRight: -10,
    },
    listWrapper: {
      width: 250,
    },
    spinnerWrapper: {
      width: 35,
      height: 22,
      padding: 3,
    },
    visionCommentPopper: {
      background: "#fff",
      width: 315,
      borderRadius: 10,
      boxShadow: "0px 1px 12px #00000029",
      zIndex: 99999,
    },
  };
});

export default useStyles;
